<script>
import {
  authComputed,
  authMethods,
  trainerMethods,
  trainerComputed,
  adminPanelComputed,
  adminPanelMethods,
  clientComputed,
  clientMethods,
  organizationComputed,
} from '@state/helpers';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import moment from 'moment';

export default {
  props: {
    subscribers: {
      type: Array,
      required: true,
      default: () => [],
    },
    user: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      selectedNewSubscriber: null,
      removingPrice: null,
      isLoading: false,
    };
  },
  mounted() {},
  computed: {
    ...authComputed,
    ...adminPanelComputed,
    ...trainerComputed,
    ...clientComputed,
    ...organizationComputed,
    duration() {
      let count = 0;
      if (this.selectedProduct) {
        const product = this.selectedProduct;
        if (
          product.type === 'recurring' &&
          product.recurring.interval === 'week'
        ) {
          count += parseInt(product.recurring.interval_count);
        } else if (
          product.type === 'recurring' &&
          product.recurring.interval === 'month'
        ) {
          count += parseInt(product.recurring.interval_count) * 4;
        } else if (
          product.type === 'one_time' &&
          product.metadata &&
          product.metadata.access_length
        ) {
          count += parseInt(product.metadata.access_length);
        }
      }
      return count === 0 || count === 1 ? `${count} week` : `${count} weeks`;
    },
    price() {
      let price = 0;
      if (this.selectedProduct) {
        price = parseInt(this.selectedProduct.unit_amount) / 100;
      }
      return price;
    },
    isSubscription() {
      return this.selectedProduct && this.selectedProduct.type === 'recurring'
        ? 'Yes'
        : 'No';
    },
    subscriberOpt() {
      const clients = cloneDeep(this.allClient);
      const smartPayClients = clients.filter((client) => {
        if (
          has(client.invitation, 'price_plan') &&
          has(client.profile, 'subscribed_plan')
        ) {
          if (
            client.profile.subscribed_plan &&
            client.profile.subscribed_plan !== this.selectedProduct.id
          ) {
            return client;
          } else if (
            client.invitation.price_plan &&
            client.invitation.price_plan !== this.selectedProduct.id
          ) {
            return client;
          } else if (
            !client.invitation.price_plan &&
            !client.profile.subscribed_plan
          ) {
            return client;
          }
        }
      });
      smartPayClients.forEach((client) => {
        if (client.profile) {
          client.label = `${client.profile.firstName} ${client.profile.lastName}`;
        }
      });
      return smartPayClients;
    },
  },
  methods: {
    ...trainerMethods,
    ...authMethods,
    ...adminPanelMethods,
    ...clientMethods,
    removeSubscriber() {
      console.log('removeSubscriber');
    },
    onSelectNewSubscriber(val) {
      if (val) {
        const client = cloneDeep(val);
        delete client.label;
        delete client.hasUnreadMessages;
        this.selectedNewSubscriber = client;
      }
    },
    getSubscriberAvatar(subscriber) {
      return subscriber &&
        subscriber.profile &&
        subscriber.profile.mediaAssets &&
        subscriber.profile.mediaAssets.avatarImage &&
        subscriber.profile.mediaAssets.avatarImage.url
        ? subscriber.profile.mediaAssets.avatarImage.url
        : require('@assets/images/placeholder-avatar.png');
    },
    removePricing() {
      this.removingPrice = this.selectedProduct.id;
      const productId = this.user.trainer.myProducts[0].id;
      const priceId = this.selectedProduct.id;
      this.deleteTrainerProductPrice({
        trainerId: this.user.trainer._id,
        productId,
        priceId,
      })
        .then((res) => {
          this.removingPrice = null;
          this.removePrice(priceId);
          this.setHideAdminPanel();
        })
        .catch((error) => {
          this.removingPrice = null;
          console.warn(error);
        });
    },
    isInvited(client) {
      return (
        !isEmpty(client.invitation.sent_at) ||
        !isEmpty(client.invitation.reSent_at) ||
        client.profile.lastSeen ||
        client.profile.last_seen ||
        (has(client.profile, 'successfulSignup') &&
          client.profile.successfulSignup)
      );
    },
    onAddSubscriber() {
      this.isLoading = true;
      const client = this.selectedNewSubscriber;
      const currentSubId = this.selectedProduct.id;

      const invitePayload = {
        client_id: client._id,
        trainer_id: client.trainer_id,
      };

      let updatePayload = {};
      if (
        (client &&
          client.invitation &&
          has(client.invitation, 'price_plan') &&
          !client.invitation.price_plan) ||
        !has(client.invitation, 'price_plan')
      ) {
        updatePayload = {
          ...client,
          invitation: { ...client.invitation, price_plan: currentSubId },
          profile: { ...client.profile, subscribed: false },
        };
      } else {
        if (
          client &&
          client.profile &&
          has(client.profile, 'subscribed_plan') &&
          client.profile.subscribed_plan &&
          has(client.profile, 'start_date') &&
          client.profile.start_date &&
          has(client.profile, 'end_date') &&
          client.profile.end_date &&
          has(client.profile, 'subscribed') &&
          client.profile.subscribed &&
          !moment(client.profile.end_date).isBefore()
        ) {
          updatePayload = {
            ...client,
            profile: { ...client.profile, subscribed_plan: currentSubId },
          };
        } else {
          updatePayload = {
            ...client,
            profile: {
              ...client.profile,
              subscribed_plan: currentSubId,
              subscribed: false,
            },
          };
        }
      }
      delete updatePayload.hasUnreadMessages;

      this.updateClient({ clientObj: updatePayload })
        .then(async (res) => {
          try {
            if (res.client) {
              if (res && res.client && !this.isInvited(res.client)) {
                await this.inviteClient({ inviteObj: invitePayload });
              }
              const updatedClient = await this.getClient({
                clientObj: res.client,
              });
              await this.setUpdateClientItem(updatedClient);
            }
          } catch (e) {
            console.log(e);
          }
          this.isLoading = false;
          this.selectedNewSubscriber = null;
          if (this.$refs && this.$refs.vSelect) {
            this.$refs.vSelect.clearSelection();
          }
        })
        .catch((e) => console.log(e));
    },
    isSubscriptionActivated(subscriber) {
      if (
        subscriber &&
        subscriber.profile &&
        has(subscriber.profile, 'subscribed_plan') &&
        subscriber.profile.subscribed_plan &&
        has(subscriber.profile, 'start_date') &&
        subscriber.profile.start_date &&
        has(subscriber.profile, 'end_date') &&
        subscriber.profile.end_date &&
        has(subscriber.profile, 'subscribed') &&
        subscriber.profile.subscribed &&
        !moment(subscriber.profile.end_date).isBefore()
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPlanActivated(subscriber) {
      if (
        subscriber.profile &&
        has(subscriber.profile, 'subscribed') &&
        subscriber.profile.subscribed &&
        has(subscriber.profile, 'subscribed_plan') &&
        subscriber.profile.subscribed_plan &&
        has(subscriber.profile, 'start_date') &&
        subscriber.profile.start_date &&
        has(subscriber.profile, 'end_date') &&
        subscriber.profile.end_date &&
        subscriber.profile.subscribed_plan !== null &&
        subscriber.profile.subscribed_plan !== undefined &&
        subscriber.profile.start_date !== null &&
        subscriber.profile.start_date !== undefined &&
        subscriber.profile.end_date !== null &&
        subscriber.profile.end_date !== undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<template>
  <div class="product-detail-container" v-if="selectedProduct">
    <div class="rows-wrapper">
      <div class="title-row row">
        <div class="title-container col">
          <label>Product Title</label>
          <span class="title">{{ selectedProduct.nickname }}</span>
        </div>
      </div>

      <div class="details-row row">
        <div class="details-col col">
          <label>Duration</label>
          <label>{{ duration }}</label>
        </div>
        <div class="details-col col">
          <label>Price</label>
          <label>${{ price }}</label>
        </div>
        <div class="details-col col">
          <label>{{ organizationTitle }} PAY?</label>
          <label class="subscription">{{ isSubscription }}</label>
        </div>
      </div>

      <div class="subscribers-row row">
        <div
          :class="[
            'subscribers-container',
            'col',
            { empty: subscribers && subscribers.length === 0 },
          ]"
        >
          <label>Subscribers</label>
          <div
            :class="[
              'subscribers-container',
              { empty: subscribers && subscribers.length === 0 },
            ]"
          >
            <p
              class="no-subscribers"
              v-if="subscribers && subscribers.length === 0"
              >no subscribers for this product</p
            >
            <template v-for="subscriber in subscribers">
              <div
                class="subscriber-row row"
                :key="subscriber._id"
                v-if="subscriber.profile"
              >
                <div>
                  <img :src="getSubscriberAvatar(subscriber)" />
                  <label>{{
                    `${subscriber.profile.firstName} ${
                      subscriber.profile.lastName
                    } ${!isPlanActivated(subscriber) ? '(pending...)' : ''}`
                  }}</label>
                </div>
                <!-- TODO: enable when API is ready -->
                <!-- <div class="trash-icon-wrapper" @click="removeSubscriber">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.004 4H13.371M5.162 4V2.667c0-.354.133-.693.37-.943s.558-.39.893-.39H8.95c.335 0 .656.14.893.39s.37.589.37.943V4m1.894 0v9.333c0 .354-.133.693-.37.943a1.23 1.23 0 01-.893.39H4.53a1.23 1.23 0 01-.893-.39c-.237-.25-.37-.59-.37-.943V4h8.841zM6.425 7.333v4M8.95 7.333v4" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div> -->
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="add-subscriber-row">
        <label>Add Subscriber</label>
        <div class="add-action">
          <div class="col-9">
            <v-select
              ref="vSelect"
              :options="subscriberOpt"
              :searchable="false"
              :clearable="false"
              placeholder="Select"
              @input="onSelectNewSubscriber"
            >
              <template v-slot:option="option">
                <span
                  :class="
                    isSubscriptionActivated(option) ? 'subscription-active' : ''
                  "
                  >{{ option.label
                  }}{{
                    isSubscriptionActivated(option)
                      ? ' - already subscribed to different product'
                      : ''
                  }}</span
                >
              </template>
            </v-select>
          </div>
          <div class="col">
            <BaseButton
              :disabled="!selectedNewSubscriber"
              type="button"
              class="btn-secondary btn-round"
              @click="onAddSubscriber"
            >
              <span v-if="!isLoading">Add</span>
              <BaseIcon v-if="isLoading" name="sync" spin />
            </BaseButton>
          </div>
        </div>
        <p
          class="invite-warning"
          v-if="selectedNewSubscriber && !isInvited(selectedNewSubscriber)"
        >
          {{ selectedNewSubscriber.profile.firstName }} hasn’t been invited yet.
          Adding {{ selectedNewSubscriber.profile.firstName }} will also send an
          invite to the {{ organizationTitle }} app.</p
        >
      </div>
    </div>
    <div class="archive-btn">
      <BaseButton
        type="button"
        :class="['btn-secondary', 'btn-round']"
        @click="removePricing"
        :disabled="subscribers && subscribers.length > 0"
      >
        <span v-if="!removingPrice">Archive Product</span>
        <BaseIcon v-if="removingPrice" name="sync" spin />
      </BaseButton>
      <p
        >*There have to be no subscribers to be able to archive this product.</p
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.invite-warning {
  color: red;
  width: 80%;
}
.product-detail-container {
  height: 100vh;
}
.rows-wrapper {
  padding-bottom: 43rem;
}
.col {
  padding-left: unset;
  padding-right: unset;
}
.col-9 {
  padding-left: unset;
  padding-right: unset;
  .v-select {
    height: fit-content;
    width: 100%;
  }
  ::v-deep .vs__dropdown-toggle {
    width: 100%;
  }
  ::v-deep .vs__dropdown-menu {
    height: 200px;
  }
}

.add-action {
  .col {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button {
    margin-bottom: 3rem;
    min-width: 8rem;
    width: 50%;
    &:disabled {
      opacity: 0.5;
      &:hover {
        background-color: white;
        color: $color-action;
      }
    }
  }
  ::v-deep .vs__search {
    padding-bottom: 5px;
  }
}

.archive-btn {
  background-color: white;
  bottom: 8rem;
  position: absolute;
  width: 100%;
  .btn-secondary {
    &:disabled {
      opacity: 0.5;
      &:hover {
        background-color: white;
        color: $color-action;
      }
    }
  }
}

.title-row {
  margin-left: 2rem;
  margin-right: 2rem;
}
.title-container {
  border-bottom: 1px solid rgba($color-gray-wo-rgb, 0.5);
  color: black;
  display: flex;
  flex-direction: column;
  text-align: start;
}
.subscribers-container {
  @extend .title-container;

  border-bottom: unset;
  height: 10vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  &:not(.empty) {
    height: 30vh;
  }
  .no-subscribers {
    color: rgba($color-black-wo-rgb, 0.6);
  }
}
.title {
  background: transparent;
  border: 0;
  color: black;
  font-size: 3.5rem;
  font-weight: 900;
  letter-spacing: -0.761905px;
  line-height: 4.2rem;
  padding: 0;
  text-align: start;
  transition: border-bottom $duration-animation-base ease-in-out;
  width: 100%;
}

.details-row {
  border-bottom: 1px solid rgba($color-gray-wo-rgb, 0.5);
  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 2.5rem;
}
.details-col {
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  .subscription {
    font-size: 14px;
    font-weight: 700;
    text-transform: unset;
  }
}

.add-subscriber-row {
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
  div {
    align-items: center;
    // margin-top: 1rem;
    display: flex;
    justify-content: space-between;
  }
}

.subscribers-row {
  label {
    color: $color-dark-gray-four;
  }

  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 2.5rem;
  .subscriber-row {
    align-items: center;
    display: flex;
    display: inline !important;
    // margin-bottom: 2rem;
    // margin-top: 2rem;
    // margin-left: 0.2rem;
    // margin-right: 2rem;

    float: none;
    justify-content: space-between;
    margin: 0 0 2rem 2px;
    label {
      color: black;
      font-size: 16px;
      font-style: normal;
      font-weight: 800;
      line-height: 22px;
      margin-bottom: unset;
      text-transform: unset;
    }
    img {
      border-radius: 50%;
      height: 3rem;
      margin-right: 10px;
      object-fit: cover;
      width: 3rem;
    }
    .trash-icon-wrapper {
      align-items: center;
      align-self: flex-end;
      border: 2px solid $color-action;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      height: 3.5rem;
      justify-content: center;
      outline: unset;
      // padding: 0.9rem;
      width: 3.5rem;
      svg {
        color: $color-action;
        height: 21px;
        outline: unset;
        width: 21px;
        path {
          stroke: $color-action;
        }
      }
      &:hover {
        background-color: $color-action;
        svg {
          path {
            stroke: white;
          }
        }
      }
    }
  }
}
.subscription-active {
  color: $color-light-gray-nine;
}
</style>
